import { render } from "./LayersPanelModifiers.vue?vue&type=template&id=45e91a17&scoped=true&ts=true"
import script from "./LayersPanelModifiers.vue?vue&type=script&lang=ts"
export * from "./LayersPanelModifiers.vue?vue&type=script&lang=ts"

import "./LayersPanelModifiers.vue?vue&type=style&index=0&id=45e91a17&lang=scss&scoped=true"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e91a17"]])

export default __exports__